import { lazy } from 'react';
import { operationsPaths } from './operations.paths';

const RefinPage = lazy(() =>
  import('pages/Operations/Refin/Refin').then((m) => ({
    default: m.RefinPage,
  })),
);

const TabDetailsPage = lazy(() =>
  import('pages/commons/TabDetails/TabDetails').then((m) => ({
    default: m.TabDetails,
  })),
);

export const operationsRoutes = [
  { path: operationsPaths.refin, element: <RefinPage /> },
  { path: operationsPaths.refinDetails, element: <TabDetailsPage /> },
];
